import React from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getModalState, setModalState } from '../../globals/application';

/**
 * CustomModal - A modal component that renders content in a portal
 *
 * @param {Object} props
 * @param {string} props.buttonLabel - Label for the button that opens the modal
 * @param {React.ReactNode} props.content - Content to render inside the modal (can be a component with props)
 * @param {string} [props.title] - Optional custom title for the modal header
 * @param {boolean} [props.disabled] - If true, the button is disabled
 */
export default function CustomModal({
  buttonLabel,
  content,
  title = 'Add Question',
  disabled = false,
}) {
  const modal = useSelector(getModalState);
  const dispatch = useDispatch();

  const open = () => dispatch(setModalState(true));
  const close = () => dispatch(setModalState(false));

  return (
    <>
      <button
        type="button"
        className="btn btn-ghost btn-sm"
        onClick={open}
        disabled={disabled}
        style={disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
      >
        {buttonLabel}
      </button>

      {modal &&
        createPortal(
          <div className="modal-overlay" onClick={close}>
            <div className="modal-box" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h3>{title}</h3>
                <button className="modal-close" onClick={close}>
                  &#x2715;
                </button>
              </div>
              <div className="modal-body">{content}</div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}
